import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

import {
  buildArtworkSeoMetadata,
  buildArtworkStructuredData,
} from '@/pages/artwork/utils/artworkSeo.utils';
import { resolveAuctionSharePayload } from '@/pages/artwork/utils/share.utils';
import {
  buildLocalizedAlternateUrls,
  resolveCurrentPathLocale,
  resolveLocalizedCanonicalUrl,
} from '@/utils/localePublicUrl';

const ArtworkMetaDesc = ({ artworkData }) => {
  const { pathname: url, search } = useLocation();
  const metadata = buildArtworkSeoMetadata({
    artworkData,
    pathname: url,
  });
  const resolvedLocale = resolveCurrentPathLocale();
  const resolvedCanonicalUrl = resolveLocalizedCanonicalUrl({ canonicalUrl: metadata.canonicalUrl, locale: resolvedLocale });
  const alternateUrls = buildLocalizedAlternateUrls({ canonicalUrl: metadata.canonicalUrl, locale: resolvedLocale });

  const sharedByUsername = new URLSearchParams(search).get('shared_by');

  const {
    shareTitle,
    shareDescription,
    shareUrl,
    shareImageUrl,
  } = resolveAuctionSharePayload({ artworkData, sharerUsername: sharedByUsername });

  const schema = buildArtworkStructuredData({
    artworkData,
    metadata,
  });
  
  // Check if the last element of the arrayUrl matches the slug by comparing them.
  const artworkDataMachesURL = url.endsWith(artworkData?.slug);

  return (
    <>
      { artworkDataMachesURL &&   
      <Helmet>
        <html lang={resolvedLocale} />
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.metaDescription} />
        <meta name="robots" content={metadata.robots} />
        <meta name="googlebot" content={metadata.robots} />
        <link rel="canonical" href={resolvedCanonicalUrl} />
        {alternateUrls.map((alternate) => (
          <link key={alternate.hrefLang} rel="alternate" hrefLang={alternate.hrefLang} href={alternate.href} />
        ))}
        <meta property="og:type" content={metadata.ogType || "product"} />
        <meta property="og:title" content={shareTitle || metadata.title} />
        <meta property="og:description" content={shareDescription || metadata.metaDescription} />
        <meta property="og:url" content={shareUrl || resolvedCanonicalUrl} />
        <meta property="og:image" content={shareImageUrl || metadata.ogImage} />
        <meta property="og:site_name" content="Suarte" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={shareTitle || metadata.title} />
        <meta name="twitter:description" content={shareDescription || metadata.metaDescription} />
        <meta name="twitter:image" content={shareImageUrl || metadata.ogImage} />
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      </Helmet>
      }
      
    </>

  );
};

export default ArtworkMetaDesc;
